/**
 * /operations/eos/article-80-classify — M3X.EOS F.6 KEYSTONE page.
 *
 * Standalone page wrapping <Article80ClassifyWizard /> so HR can
 * classify a termination-with-cause case standalone (without
 * having opened the EOS workflow yet).
 *
 * On confirm: redirects to /operations/transactions/eos/new with
 * the chosen Article 80 subtype pre-filled (or to a
 * termination-without-cause flow if HR rejects Article 80).
 */

import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { PageHeader } from "../components/ui";
import { Article80ClassifyWizard } from "../components/eos/Article80ClassifyWizard";

export function Article80WizardPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="space-y-6">
      <PageHeader
        title={t(
          "article_80_page.title",
          "Article 80 — Termination With Cause Classifier",
        )}
        subtitle={t(
          "article_80_page.subtitle",
          "Sonnet classifies the case into one of 11 subtypes. You have final say.",
        )}
      />
      <Article80ClassifyWizard
        onConfirm={(subtypeCode) => {
          if (subtypeCode === null) {
            navigate(
              "/operations/transactions/eos/new?trigger=termination_without_cause",
            );
          } else {
            navigate(
              `/operations/transactions/eos/new?trigger=termination_with_cause&subtype=${encodeURIComponent(subtypeCode)}`,
            );
          }
        }}
      />
    </div>
  );
}

export default Article80WizardPage;
